import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterPipe } from '../../pipe/filter.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { AppTooltipDirective  } from '../../directives/tooltip.directive';
import { MinuteSecondsPipePipe } from '../../pipe/minute-seconds-pipe.pipe';
import { SearchPipe } from '../../pipe/search.pipe';
import { ReadMoreDirective } from '../../directives/read-more.directive';
import { NoWhitespaceDirective } from '../../directives/no-whitespace.directive';
import { HighlightDirective } from '../../pipe/search-text-highlight/highlight.directive';
import { HighlightwordDirective } from '../../directives/highlightword.directive';
import { PasswordMaskDirective } from '../../directives/password-mask.directive';
import { ArraytostringPipe } from '../../pipe/arraytostring.pipe';
import { ArrayformationPipe } from '../../pipe/arrayformation.pipe';
import { ReadMoreExpandDirective } from '../../directives/read-more-expand.directive';
import { ToggleDirective } from '../../directives/toggle.directive';
import {
  SelectDropdownComponent,
  SelectDropdownDirective,
} from '../../formcomponents/select-dropdown/select-dropdown.component';
import { ReplaceLineBreaksPipe } from '../../pipe/replace-line-breaks.pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { TagInputModule } from 'ngx-chips';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { CustomInfiniteScrollDirective } from '../../directives/custom-infinite-scroll';
import { ProgressSpinnerComponent } from '../../components/progress-spinner/progress-spinner.component';
import { ProgressSpinerService } from '../../services/progress-spiner.service';
import { NgxExcelViewerModule } from '../../components/ngx-excel-viewer/ngx-excel-viewer.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ToolDropdownDirective } from '../../directives/tool-dropdown.directive';
import { DialogModalComponent } from '../../components/dialog-modal/dialog-modal.component';
import { ChatBotQueryComponent } from '../../components/chat-bot-query/chat-bot-query.component';
import { SearchHighlightPipe } from '../../pipe/search-highlight.pipe';
import { BotQuestionAnswerComponent } from '../../components/bot-question-answer/bot-question-answer.component';
import { LoadersInlineComponent } from '../../components/loaders-inline/loaders-inline.component';
import { ToggleIconModule } from '../../components/toggle-icon/toggle-icon.module';
import { TrimTextDirective } from '../../directives/trim-text.directive';
import { PhoneInputComponent } from '../../components/phone-input/phone-input.component';
@NgModule({
  declarations: [
    FilterPipe,
    MinuteSecondsPipePipe,
    SearchPipe,
    ReadMoreDirective,

    NoWhitespaceDirective,
    HighlightDirective,

    HighlightwordDirective,
    PasswordMaskDirective,
    ArraytostringPipe,
    ArrayformationPipe,
    ReadMoreExpandDirective,
    ToggleDirective,
    SelectDropdownDirective,
    TrimTextDirective,
    ReplaceLineBreaksPipe,
    SearchHighlightPipe,
    SelectDropdownComponent,
    CustomInfiniteScrollDirective,
    ProgressSpinnerComponent,
    ToolDropdownDirective,
    DialogModalComponent,
    ChatBotQueryComponent,
    BotQuestionAnswerComponent,
    LoadersInlineComponent,
    PhoneInputComponent,
  ],
  exports: [
    FilterPipe,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxPaginationModule,
    AppTooltipDirective,
    MinuteSecondsPipePipe,
    SearchPipe,
    SearchHighlightPipe,
    ReadMoreDirective,
    CustomInfiniteScrollDirective,
    NoWhitespaceDirective,
    HighlightDirective,
    DialogModalComponent,
    ChatBotQueryComponent,
    BotQuestionAnswerComponent,
    LoadersInlineComponent,
    PhoneInputComponent,
    HighlightwordDirective,
    PasswordMaskDirective,
    ArraytostringPipe,
    ArrayformationPipe,
    ReadMoreExpandDirective,
    TrimTextDirective,
    ToggleDirective,
    ToolDropdownDirective,
    SelectDropdownDirective,
    ReplaceLineBreaksPipe,
    NgxDaterangepickerMd,
    SelectDropdownComponent,
    TagInputModule,
    AngularEditorModule,
    NgxDocViewerModule,
    NgxExcelViewerModule,
    PdfViewerModule,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    AppTooltipDirective,
    NgxPaginationModule,
    NgxDaterangepickerMd.forRoot(),
    TagInputModule,
    AngularEditorModule,
    NgxDocViewerModule,
    ToggleIconModule,
    NgxExcelViewerModule,
    PdfViewerModule,
  ],
  providers: [ ProgressSpinerService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
